import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faWalking, faCircle} from '@fortawesome/free-solid-svg-icons'

import './filterpanel.css'

export default function AdvancingFilter (props) {
  const circleColor = props?.active ? "#9ee3ff": "#E3E2E5"
  return (
    <>
    <span className="fa-stack row-button" onClick={props.onClick}>
      <FontAwesomeIcon icon={faCircle} color={circleColor} className="fa-stack-2x" />
      <FontAwesomeIcon icon={faWalking} color="#257461" className="fa-stack-1x"  />
    </span>
    <span className="btnlabel align-lbl">Non-Advancing</span>
    </>
  )
}